import React from 'react'
import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { SxProps, Theme, useTheme } from '@mui/material/styles'

import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined'

export type StatisticCardProps = {
  disableIcon?: boolean
  icon?: React.ReactNode
  title: string
  value: number
  sx?: SxProps<Theme>
}

export function StatisticCard(props: StatisticCardProps) {
  const { disableIcon = false, icon, title, value, sx = [] } = props
  const theme = useTheme()

  const iconComponent = icon || (
    <Avatar sx={{ backgroundColor: (theme) => theme.palette.primary.main }}>
      <AssessmentOutlinedIcon />
    </Avatar>
  )

  return (
    <Card
      sx={[
        {
          display: 'flex',
          flexDirection: 'column',
          p: '24px',
          minHeight: '100%',
        },
        !disableIcon && { alignItems: 'center', flexDirection: 'row' },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Stack justifyContent="space-between" flex={1} height="100%" spacing={1}>
        <Typography variant="h6" sx={{ color: 'inherit', fontWeight: 600, fontSize: '14px' }}>
          {title}
        </Typography>
        <Typography
          sx={{
            color: 'inherit',
            fontSize: '24px',
            fontWeight: 700,
            lineHeight: '30px',
            [theme.breakpoints.up('sm')]: {
              fontSize: '26px',
            },
            [theme.breakpoints.up('md')]: {
              fontSize: '30px',
            },
            [theme.breakpoints.up('lg')]: {
              fontSize: '32px',
            },
          }}
          variant="h3"
        >
          {value}
        </Typography>
      </Stack>
      {!disableIcon && <Box sx={{ minHeight: '36px' }}>{iconComponent}</Box>}
    </Card>
  )
}

export default StatisticCard
